import { useState, useEffect } from 'preact/hooks';
import useVendor from './useVendor';
import { articleTypes } from '../config/product';
import { HookState } from '../types/hooks';

const ARTICLE_TYPE_AND_SFPROUTE_MAP = {
    [articleTypes.calendar]: 'calendar_category_year', // "/photo-calendars"
    [articleTypes.card]: 'cards', // "/personalised-cards"
    [articleTypes.photobook]: 'photo_book_category', // "/photo-books"
    [articleTypes.paddedPhotoBook]: 'photo_book_category', // "/photo-books"
    [articleTypes.cutoutPhotoBook]: 'photo_book_category', // "/photo-books"
    [articleTypes.momentsPhotoBook]: 'photo_book_category', // "/photo-books"
    [articleTypes.prints]: 'prints_category', // "/photo-printing"
    [articleTypes.aluminium]: 'product_pages_aluminium', // "/wall-art/aluminium-prints"
    [articleTypes.canvas]: 'product_pages_canvas', // "/wall-art/canvas-prints"
    [articleTypes.forex]: 'product_pages_forex', // "/wall-art/mounted-prints"
    [articleTypes.mug]: 'product_pages_mugs', // "/personalised-mugs"
    [articleTypes.lovemug]: 'product_pages_mugs', // "/personalised-mugs"
    [articleTypes.magicmug]: 'product_pages_mugs', // "/personalised-mugs"
    [articleTypes.jigsaw]: 'product_pages_jigsaws', // "/personalised-jigsaw"
    [articleTypes.cushion]: 'product_pages_cushions', // "/personalised-cushion"
    [articleTypes.magnet]: 'product_pages_magnets', // "/photo-magnets"
    [articleTypes.plexiglas]: 'product_pages_plexiglas', // "/wall-art/acrylic-prints"
    [articleTypes.poster]: 'product_pages_poster', // "/wall-art/poster-printing"
    [articleTypes.studentPlakat]: 'product_pages_studentplakat', // "/studentplakat"
    [articleTypes.voucher]: 'voucher_overview', // "/gift-vouchers"
};

/**
 * Fetch storefront routes
 * @return {{data: Object|null, loading: boolean, error: boolean}}
 */
const useStorefrontBaseRoutes = (storefrontConfig): HookState => {
    const [status, setStatus] = useState<HookState>({
        loading: true,
        error: false,
        data: null,
    });

    const vendor = useVendor();

    useEffect(() => {
        (async () => {
            if (storefrontConfig && !storefrontConfig.loading && !storefrontConfig.error) {
                // Declaring these variables inside try{...} statement
                // leads to a babel compilation error when running Jest tests.
                let response, routes;
                const mappedRoutes = {};

                try {
                    const baseVendorUrl = storefrontConfig.data.routes.Main;
                    const url = `${baseVendorUrl}/platform/all-routes`;
                    response = await fetch(url);
                    if (!response.ok) {
                        throw new Error(`${response.status} ${response.statusText}`);
                    }

                    routes = await response.json();
                    for (const key in ARTICLE_TYPE_AND_SFPROUTE_MAP) {
                        const articleTypeUrl = routes[ARTICLE_TYPE_AND_SFPROUTE_MAP[key]];
                        mappedRoutes[key] = `${baseVendorUrl}${articleTypeUrl}`;
                    }
                    setStatus({ loading: false, error: false, data: mappedRoutes });
                } catch (error: any) {
                    console.error(`Storefront routes error: ${error.message}`);
                    setStatus({ loading: false, error: true, data: null });
                }
            }
        })();
    }, [vendor, storefrontConfig]);

    return status;
};

export default useStorefrontBaseRoutes;
